import type { IndividualCapacitySchema, TimelineDtoSchema } from "@nexttrack/api-schema";

import { rootApi } from "@/store/services/root-api";

export const capacityApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getTimeline: builder.query<
            TimelineDtoSchema,
            { from: string; to: string; departmentId?: string; teamId?: string }
        >({
            query: (params) => ({ url: "timeline", params }),
            providesTags: ["Timeline"],
        }),
        getIndividualCapacity: builder.query<
            IndividualCapacitySchema,
            { individualId: string; startDate: string; endDate: string; excludeBookingId?: string }
        >({
            query: ({ individualId, startDate, endDate, excludeBookingId }) => ({
                url: `individuals/${individualId}/capacity`,
                params: { startDate, endDate, ...(excludeBookingId ? { excludeBookingId } : {}) },
            }),
            providesTags: ["Timeline"],
        }),
    }),
});

export const { useGetTimelineQuery, useGetIndividualCapacityQuery } = capacityApi;
